var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml-1 mb-1 text-purple-ap-100 bg-white text-xs rounded mx-2 uppercase"},[_c('i',{staticClass:"text-md mr-1 material-icons align-middle text-purple-ap-100"},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }